import { render, staticRenderFns } from "./OsPicker.vue?vue&type=template&id=76fd1370&scoped=true&"
import script from "./OsPicker.vue?vue&type=script&lang=ts&"
export * from "./OsPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fd1370",
  null
  
)

export default component.exports